import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_URL,
});

api.interceptors.request.use(function(config){
  if(config.url !== `/login?token=${process.env.REACT_APP_TOKEN_API}` && config.headers !== undefined){
    const token = localStorage.getItem(String(process.env.REACT_APP_LOCAL_KEY));

    config.headers['Authorization'] = `Bearer ${token}`

    return config
  }

  return config
}, function(error){
  return Promise.reject(error);
})
export { api };
